<div class="flex column start center w-100 container">
	<h4>{{ 'course-creation.add_description_to_file' | translateWithKeys }}</h4>
	<mat-form-field appearance="outline" class="w-100">
		<textarea cdkTextareaAutosize matInput [placeholder]="'general.description' | translateWithKeys" rows="4" [(ngModel)]="description"></textarea>
	</mat-form-field>
	<div class="flex row end w-100 gap">
		<button mat-stroked-button class="button" (click)="close()">
			{{ 'general.cancel' | translateWithKeys }}
		</button>
		<button mat-flat-button class="button btn-primary bg-primary-darker text-accent-lighter" (click)="save()">
			{{ 'general.save' | translateWithKeys }}
		</button>
	</div>
</div>
